import { render, staticRenderFns } from "./reminderMessage.vue?vue&type=template&id=1ed23bea&scoped=true"
import script from "./reminderMessage.vue?vue&type=script&lang=js"
export * from "./reminderMessage.vue?vue&type=script&lang=js"
import style0 from "./reminderMessage.vue?vue&type=style&index=0&id=1ed23bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed23bea",
  null
  
)

export default component.exports